export enum CardState {
  Pending = 'Pending',
  Ordered = 'Ordered',
  Ready = 'Ready',
  Delivered = 'Delivered',
}

export enum TagType {
  MEMBER = 'Member',
  VISITOR = 'Visitor',
}
